import "./ConvertForecastTemperature.css";

export default function ConvertForecastTemperature(props) {
  let tempMax = Math.round(props.tempMax);
  let tempMin = Math.round(props.tempMin);

  if (props.unit === "fahrenheit") {
    tempMax = Math.round(tempMax * (9 / 5) + 32);
    tempMin = Math.round(tempMin * (9 / 5) + 32);
  }

  return (
    <div className="weather-forecast-temperatures">
      <span>
        <strong>{tempMax}°</strong>
      </span>
      <span>{tempMin}°</span>
    </div>
  );
}
